import { z } from 'zod';

export const provinceSchema = z.object({
  id: z.string(),
  province: z.string(),
});

export type Province = z.infer<typeof provinceSchema>;
